function transformItem2Dto(item) {
  const dto = {
    eventLogID: item.id,
    ...item,
    fromDate: item.fromDate && new Date(item.fromDate).toISOString()
  };
  delete dto.id;
  return dto;
}

export const apiOverrides = { transformItem2Dto };

export const storeExtensions = {
  actions: {
    update({ commit }, item) {
      throw new Error('Event logs are not updatable');
    },
    create({ commit }, item) {
      throw new Error('Event logs are not creatable');
    }
  }
};
